import { gql } from "@apollo/client";

export const GET_ALL_BMI_TRACKS = gql`
  query BMITracks(
    $first: Int
    $offset: Int
    $orderBy: String
    $member: String
    $weightStart: Float
    $weightEnd: Float
    $heightEnd: Float
    $heightStart: Float
    $BMIStart: Float
    $BMIEnd: Float
    $ageEnd: Float
    $ageStart: Float
    $dateStart: DateTime
    $dateEnd: DateTime
    $createdOnStart: DateTime
    $createdOnEnd: DateTime
    $weightStatus: String
  ) {
    BMITracks(
      first: $first
      offset: $offset
      orderBy: $orderBy
      member: $member
      weightStart: $weightStart
      weightEnd: $weightEnd
      heightEnd: $heightEnd
      heightStart: $heightStart
      BMIStart: $BMIStart
      BMIEnd: $BMIEnd
      ageEnd: $ageEnd
      ageStart: $ageStart
      dateStart: $dateStart
      dateEnd: $dateEnd
      createdOnStart: $createdOnStart
      createdOnEnd: $createdOnEnd
      weightStatus: $weightStatus
    ) {
      totalCount
      edges {
        node {
          objectId
          createdOn
          member {
            objectId
            user {
              name
            }
          }
          weight
          height
          BMI
          age
          date
          weightStatus
        }
      }
    }
  }
`;
export const GET_SINGLE_BMI_TRACKS = gql`
  query BMITrack($objectId: ID) {
    BMITrack(objectId: $objectId) {
      objectId
      createdOn
      member {
        user {
          name
        }
      }
      weight
      height
      BMI
      age
      date
      weightStatus
    }
  }
`;
